import { alpha, Theme } from '@mui/material/styles';

/** Frosted "glass" card surface used across the blog index and post pages. */
export const glassCardSx = (theme: Theme) => ({
  backgroundColor: alpha(theme.palette.mainColors.white, 0.7),
  backdropFilter: 'blur(16px)',
  border: `1px solid ${theme.palette.greyShades.border2}`,
  borderRadius: 3,
  transition:
    'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
});

/** Lift + glow hover treatment, paired with glassCardSx on interactive cards. */
export const glassCardHoverSx = (theme: Theme) => ({
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: `0 20px 60px ${alpha(theme.palette.mainColors.primary, 0.12)}`,
    borderColor: alpha(theme.palette.mainColors.blue, 0.35),
  },
});

/** Small uppercase pill, used for category/topic labels. */
export const pillLabelSx = {
  borderRadius: '9999px',
  fontSize: '0.65rem',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase' as const,
};
